import axios from 'axios';

const API = '/api';

// Configure axios defaults
axios.defaults.withCredentials = true;

// Events API
export const eventsApi = {
  getAll: () => axios.get(`${API}/events`),
  getActive: () => axios.get(`${API}/events/active`),
  getById: (id) => axios.get(`${API}/events/${id}`),
  create: (data) => axios.post(`${API}/events`, data),
  update: (id, data) => axios.put(`${API}/events/${id}`, data),
  delete: (id) => axios.delete(`${API}/events/${id}`),
};

// Units API
export const unitsApi = {
  getAll: (eventId = null) => axios.get(`${API}/units`, { params: eventId ? { event_id: eventId } : {} }),
  getAvailable: (eventId = null) => axios.get(`${API}/units/available`, { params: eventId ? { event_id: eventId } : {} }),
  getAssigned: (eventId = null) => axios.get(`${API}/units/assigned`, { params: eventId ? { event_id: eventId } : {} }),
  getById: (id) => axios.get(`${API}/units/${id}`),
  create: (data) => axios.post(`${API}/units`, data),
  update: (id, data) => axios.put(`${API}/units/${id}`, data),
  updateStatus: (id, status, transportDestination = null) => 
    axios.put(`${API}/units/${id}/status`, { status, transport_destination: transportDestination }),
  delete: (id) => axios.delete(`${API}/units/${id}`),
  getTransportDestinations: () => axios.get(`${API}/units/config/transport-destinations`),
};

// Unit IDs API (for managing unit ID options)
export const unitIdsApi = {
  getAll: (unitType = null) => axios.get(`${API}/unit-ids`, { params: unitType ? { unit_type: unitType } : {} }),
  create: (data) => axios.post(`${API}/unit-ids`, data),
  delete: (id) => axios.delete(`${API}/unit-ids/${id}`),
};

// Status History API (for reporting)
export const statusHistoryApi = {
  getAll: (params = {}) => axios.get(`${API}/status-history`, { params }),
  getByUnit: (unitDbId) => axios.get(`${API}/status-history/unit/${unitDbId}`),
  getUnitActivity: () => axios.get(`${API}/status-history/unit-activity`),
  getUnitReport: (params = {}) => axios.get(`${API}/status-history/unit-report`, { params }),
  getResponseTimes: (params = {}) => axios.get(`${API}/status-history/response-times`, { params }),
};

// Auth API
export const authApi = {
  login: (data) => axios.post(`${API}/auth/login`, data),
  logout: () => axios.post(`${API}/auth/logout`),
  me: () => axios.get(`${API}/auth/me`),
  changePassword: (newPassword) => axios.post(`${API}/auth/change-password`, { new_password: newPassword }),
  getUsers: () => axios.get(`${API}/auth/users`),
  createUser: (data) => axios.post(`${API}/auth/users`, data),
  updateUser: (id, data) => axios.put(`${API}/auth/users/${id}`, data),
  deleteUser: (id) => axios.delete(`${API}/auth/users/${id}`),
  resetPassword: (id) => axios.post(`${API}/auth/users/${id}/reset-password`),
};

// Employees API
export const employeesApi = {
  getAll: () => axios.get(`${API}/employees`),
  create: (data) => axios.post(`${API}/employees`, data),
  update: (id, data) => axios.put(`${API}/employees/${id}`, data),
  delete: (id) => axios.delete(`${API}/employees/${id}`),
  uploadExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/employees/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
};

// Calls API
export const callsApi = {
  getAll: (eventId = null, status = null) => {
    const params = {};
    if (eventId) params.event_id = eventId;
    if (status) params.status = status;
    return axios.get(`${API}/calls`, { params });
  },
  getActive: (eventId = null) => axios.get(`${API}/calls/active`, { params: eventId ? { event_id: eventId } : {} }),
  getById: (id) => axios.get(`${API}/calls/${id}`),
  create: (data) => axios.post(`${API}/calls`, data),
  update: (id, data) => axios.put(`${API}/calls/${id}`, data),
  setDisposition: (callId, disposition, unitId) => axios.post(`${API}/calls/${callId}/disposition`, { disposition, unit_id: unitId }),
  cancel: (callId) => axios.post(`${API}/calls/${callId}/cancel`),
  getPerHour: () => axios.get(`${API}/calls/per-hour`),
};

// Reports API
export const reportsApi = {
  getDailySummary: (params = {}) => axios.get(`${API}/reports/daily-summary`, { params }),
};

// Assignments API
export const assignmentsApi = {
  create: (callId, unitId) => axios.post(`${API}/assignments`, { call_id: callId, unit_id: unitId }),
  remove: (callId, unitId) => axios.delete(`${API}/assignments/${callId}/${unitId}`),
};
